import {
    Box,
    Paper, Typography, useTheme,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    tableCellClasses,
    styled,
    FormControl,
    FormControlLabel,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import React, { useEffect, useMemo, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { ILstDrop, TDropOptions, TipoSalario, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { IDadosListaFranquiaLiga, IDadosListaJogadores, IDadosListao, IListagemLigas, LigaService } from "../../shered/services/api/liga/LigaService";
import { DialogEvent, IDadosModalEvento } from "../../shered/components/modal/DialogEvent";
import { moedaRealLocaleValue } from "../../shered/components/input-valor-moeda/Current-Mask";

export const ListagemDeListao: React.FC = () => {
    const theme = useTheme();
    const refTab = useRef<any>(null);
    const { debounce } = useDebounce();
    const navigate = useNavigate();
    const { logout } = useAuthContext();
    const user = CookieService.get("access_user");
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [semImagem, setSemImagem] = useState<any>("../../../semimagem.png");
    const [codigoSelecionada, setCodigoSelecionada] = useState(0);
    const [searchParams, SetSearchParams] = useSearchParams();
    const [searchParamsJogadores, SetSearchParamsJogadores] = useSearchParams();
    const [isLoading, setIsLoading] = useState(true);
    const [redirecionar, setRedirecionar] = useState("");
    const [removeLoading, setRemoveLoading] = useState(false);
    const [lstTemporadas, setLstTemporadas] = useState<ILstDrop[]>([]);
    const [showDadosFranquia, setShowDadosFranquia] = useState(false);
    const [chkSerComissario, setChkSerComissario] = useState(false);
    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [dadosListao, setDadosListao] = useState<IDadosListao>();
    const [listaoRows, setListaoRows] = useState<IDadosListaFranquiaLiga[]>([]);
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [ano1, setAno1] = useState("");
    const [ano2, setAno2] = useState("");
    const [ano3, setAno3] = useState("");
    const [ano4, setAno4] = useState("");
    const [ano5, setAno5] = useState("");
    const [dadosModalMensagem, setDadosModalMensagem] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const [showModalEvent, setShowModalEvent] = useState(false);
    const [dadosModalEvent, setDadosModalEvent] = useState<IDadosModalEvento>({
        acao: false,
        label: "",
        tipo: "info",
        mensagem: "Deseja ronovar com o jogador ",
        display: "none",
        titulo: "Atenção"
    });

    const [errors, setErrors] = useState({
        error: false,
        nomeFranquiaRef: "",
        showImagemFranquia: ""
    });

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
            fontSize: UtilidadeService.isMobile() ? 10 : 14
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: UtilidadeService.isMobile() ? 10 : 14,
            padding: "4px",
            fontFamily: "sans-serif",
            fontWeight: "bold",
        },
        [`&.${tableCellClasses.footer}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        }
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td': {
            border: 0,
            fontSize: UtilidadeService.isMobile() ? 10 : 14
        },
        '&:last-child th': {
            border: 0,
            padding: UtilidadeService.isMobile() ? "8px 5px" : "16px 10px "
        },
    }));

    useEffect(() => {
        setIsLoading(true);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setDadosModalMensagem({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar("/dashboard");
            return;
        } else {
            debounce(() => {
                UtilidadeService.getTemporadas(true, Number(codigoLiga))
                    .then((result) => {
                        setIsLoading(false);
                        const tmps = result.data.dado;
                        let lstTemporadasAux = tmps.map((f, i) => ({ codigo: f.codigo, label: f.descricao_Temporada }));
                        setLstTemporadas(lstTemporadasAux);
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                    });

                LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                    .then((result) => {
                        setIsLoading(false);
                        const liga = result.dado;
                        setDadosLiga(liga);
                        if (liga.caminho_Logo !== null) {
                            setShowImagemFranquia(liga.caminho_Logo);
                        }
                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    });

                LigaService.getDadosListaoPorCodigoLiga(Number(codigoLiga))
                    .then((result) => {
                        setIsLoading(false);
                        const dados = result.dado;
                        setDadosListao(dados);
                        setListaoRows(dados.detalhes_Franquia);
                        carregarCabecalhoTemporadas(Number(codigoLiga));

                    })
                    .catch((errors) => {
                        setShowModalMensagem(true);
                        setRemoveLoading(true);
                        if (errors.response.status === 401) {
                            setDadosModalMensagem({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }

                        setDadosModalMensagem({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    });


            })
        }
    }, [codigoLiga]);

    const carregarCabecalhoTemporadas = (codigo: number) => {
        UtilidadeService.getDescricaoTemporadoPorCodigoLiga(codigo)
            .then((result) => {
                setIsLoading(false);
                const tmps = result.dado;
                setAno1(tmps.descricao_Ano1);
                setAno2(tmps.descricao_Ano2);
                setAno3(tmps.descricao_Ano3);
                setAno4(tmps.descricao_Ano4);
                setAno5(tmps.descricao_Ano5);
            })
            .catch((errors) => {
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response.status === 401) {
                    setDadosModalMensagem({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                setDadosModalMensagem({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
            });
    }

    const toggleModalMensagem = () => {
        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    const toggleModalEvent = () => {
        setShowModalEvent(modalVisivel => !modalVisivel);
        if (redirecionar !== "") {
            redirecionar.length === 1 || CookieService.get("access_token") === undefined ? navigate(0) : navigate(redirecionar);
        }
    }

    const carregaPosicao = (posicao_1: string, posicao_2: string | null, posicao_3: string | null) => {

        let posicoes = `${UtilidadeService.verificaTipoPosicao(posicao_1)} ${posicao_2 !== null ? " | " : ""} ${posicao_2 !== null ? UtilidadeService.verificaTipoPosicao(posicao_2) : ""} ${posicao_3 !== null ? " | " : ""} ${posicao_3 !== null ? UtilidadeService.verificaTipoPosicao(posicao_3) : ""}`;
        //console.log(posicoes);
        let qtd = posicoes.split("|").length;
        let arrImagens = posicoes.split("|");

        let imgs = qtd === 1 ? <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 15 : 25} height={UtilidadeService.isMobile() ? 15 : 25} style={{ borderRadius: "50%" }} />
            : qtd === 2 ?
                <>  <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 15 : 25} height={UtilidadeService.isMobile() ? 15 : 25} style={{ borderRadius: "50%" }} />
                    <img src={arrImagens[1]} alt={"img2"} width={UtilidadeService.isMobile() ? 15 : 25} height={UtilidadeService.isMobile() ? 15 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
                </>
                : <> <img src={arrImagens[0]} alt={"img1"} width={UtilidadeService.isMobile() ? 15 : 25} height={UtilidadeService.isMobile() ? 15 : 25} style={{ borderRadius: "50%" }} />
                    <img src={arrImagens[1]} alt={"img2"} width={UtilidadeService.isMobile() ? 15 : 25} height={UtilidadeService.isMobile() ? 15 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
                    <img src={arrImagens[2]} alt={"img3"} width={UtilidadeService.isMobile() ? 15 : 25} height={UtilidadeService.isMobile() ? 15 : 25} style={{ borderRadius: "50%", marginLeft: 4 }} />
                </>

        return imgs
    }

    return (
        <LayoutBaseDePagina
            titulo={`Listão - ${dadosLiga?.nome}`}
            showLogoImg={showImagemFranquia}
            barraDeFerramentas={<FerramentasDaListagem
                textoBotaoNovo="Nova"
                mostrarBotaoNovo={false}
                mostrarInputBusca={false}
                aoClicarBotaoNovo={() => navigate('/liga/franquias')}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}
            />}>

            {showModalEvent && <DialogEvent dados={dadosModalEvent} isModalVisible={showModalEvent} onBackClickClose={toggleModalEvent} />}
            {showModalMensagem && <DialogMensagem dados={dadosModalMensagem} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <Box margin={1} display="flex" component={Paper} variant="outlined"  >
                <Grid container size={{ xs: 12, sm: 12 }} sx={{ width: "100%" }}>
                    <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={2} >
                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1}>
                            <Grid size={{ xs: 12, sm: 12 }} >
                                <Typography variant="h6" style={{ fontSize: UtilidadeService.isMobile() ? 14 : 20 }}> Lista de Jogadores por Franquias </Typography>
                                <hr />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 12 }}  >
                                {listaoRows.length > 0 && listaoRows.map(f => (
                                    <>
                                        <Grid container size={{ xs: 12, sm: 12 }}>
                                            <Grid size={{ xs: 12, sm: 12 }} padding={2} display={"flex"} flexDirection={"row"}>
                                                <img src={f.caminho_Logo === "" ? showImagemFranquia : f.caminho_Logo} width={UtilidadeService.isMobile() ? 45 : 60} height={UtilidadeService.isMobile() ? 45 : 60} alt={f.logo} />
                                                &nbsp; &nbsp; &nbsp;
                                                <Typography variant={UtilidadeService.isMobile() ? "body2" : "body1"} >{f.nome}</Typography>
                                                &nbsp; &nbsp; &nbsp;
                                                <img src={f.caminho_Foto_Usuario === "" ? semImagem : f.caminho_Foto_Usuario} width={UtilidadeService.isMobile() ? 45 : 60} height={UtilidadeService.isMobile() ? 45 : 60} alt={f.foto_Usuario} />
                                                &nbsp; &nbsp; &nbsp;
                                                <Typography variant={UtilidadeService.isMobile() ? "body2" : "body1"} >{f.nome_Usuario}</Typography>
                                            </Grid>
                                            <TableContainer key={f.codigo} component={Paper} variant="outlined"  >
                                                <Table >
                                                    <TableHead >
                                                        <TableRow>
                                                            <StyledTableCell sx={{ padding: UtilidadeService.isMobile() ? "4px" : "10px", minWidth: 50 }} align="center">Foto</StyledTableCell>
                                                            <StyledTableCell sx={{ padding: UtilidadeService.isMobile() ? "4px" : "10px", minWidth: 70 }} align="left">Nome</StyledTableCell>
                                                            <StyledTableCell sx={{ padding: UtilidadeService.isMobile() ? "4px" : "10px", minWidth: 70 }} align="center">Posição</StyledTableCell>
                                                            <StyledTableCell sx={{ padding: UtilidadeService.isMobile() ? "4px" : "10px", minWidth: 70 }} align="center">{ano1}</StyledTableCell>
                                                            <StyledTableCell sx={{ padding: UtilidadeService.isMobile() ? "4px" : "10px", minWidth: 70 }} align="center">{ano2}</StyledTableCell>
                                                            <StyledTableCell sx={{ padding: UtilidadeService.isMobile() ? "4px" : "10px", minWidth: 70 }} align="center">{ano3}</StyledTableCell>
                                                            <StyledTableCell sx={{ padding: UtilidadeService.isMobile() ? "4px" : "10px", minWidth: 70 }} align="center">{ano4}</StyledTableCell>
                                                            <StyledTableCell sx={{ padding: UtilidadeService.isMobile() ? "4px" : "10px", minWidth: 70 }} align="center">{ano5}</StyledTableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {f.jogadores.map(row => (
                                                            <StyledTableRow key={row.codigo} sx={{ fontSize: "10px" }} >
                                                                <StyledTableCell align="center">
                                                                    <img src={row.foto} alt={row.nome}
                                                                        width={UtilidadeService.isMobile() ? 35 : 40} height={UtilidadeService.isMobile() ? 35 : 40}
                                                                        style={{ borderRadius: "20%" }}
                                                                        onError={({ currentTarget }) => {
                                                                            currentTarget.onerror = null;
                                                                            currentTarget.src = "../../../../semimagem.png";
                                                                            currentTarget.style.borderRadius = "50%";
                                                                            currentTarget.style.width = UtilidadeService.isMobile() ? "30px" : "40px";
                                                                            currentTarget.style.height = UtilidadeService.isMobile() ? "30px" : "40px";
                                                                        }}
                                                                    />
                                                                </StyledTableCell>
                                                                <StyledTableCell>{row.nome}
                                                                {
                                                                    <span style={{ color: "#ED59BC" }}>
                                                                        {
                                                                            row.restrito === true && row.draftado === false ? " ®" :
                                                                                row.restrito === false && row.draftado === true ? <span style={{ color: "#59cbed" }}>&nbsp;Ð</span> :
                                                                                    row.restrito === true && row.draftado === true ? <><span style={{ color: "#ED59BC" }}>&nbsp;®</span> <span style={{ color: "#59cbed" }}>&nbsp;Ð</span></> : ""
                                                                        }
                                                                    </span>}
                                                                </StyledTableCell>
                                                                <StyledTableCell align="center">{carregaPosicao(row.posicao_1, row.posicao_2, row.posicao_3)}</StyledTableCell>
                                                                <StyledTableCell align={row.salario_Ano1 === null ? "center" : "right"} style={{ color: (row.contundido || row.fora_NBA) ? "red" : TipoSalario.find(f => f.codigo === row.tipo_Salario_1)?.color }} >{row.salario_Ano1 === null ? "-" : moedaRealLocaleValue(row.salario_Ano1)}</StyledTableCell>
                                                                <StyledTableCell align={row.salario_Ano2 === null ? "center" : "right"} style={{color: (row.contundido || row.fora_NBA) ? "red" : row.tipo_Salario_2 === null ? "auto" : TipoSalario.find(f => f.codigo === row.tipo_Salario_2)?.color }}>{row.salario_Ano2 === null ? "-" : moedaRealLocaleValue(row.salario_Ano2)}</StyledTableCell>
                                                                <StyledTableCell align={row.salario_Ano3 === null ? "center" : "right"} style={{color: (row.contundido || row.fora_NBA) ? "red" : row.tipo_Salario_3 === null ? "auto" : TipoSalario.find(f => f.codigo === row.tipo_Salario_3)?.color }}>{row.salario_Ano3 === null ? "-" : moedaRealLocaleValue(row.salario_Ano3)}</StyledTableCell>
                                                                <StyledTableCell align={row.salario_Ano4 === null ? "center" : "right"} style={{color: (row.contundido || row.fora_NBA) ? "red" : row.tipo_Salario_4 === null ? "auto" : TipoSalario.find(f => f.codigo === row.tipo_Salario_4)?.color }}>{row.salario_Ano4 === null ? "-" : moedaRealLocaleValue(row.salario_Ano4)}</StyledTableCell>
                                                                <StyledTableCell align={row.salario_Ano5 === null ? "center" : "right"} style={{color: (row.contundido || row.fora_NBA) ? "red" : row.tipo_Salario_5 === null ? "auto" : TipoSalario.find(f => f.codigo === row.tipo_Salario_5)?.color }}>{row.salario_Ano5 === null ? "-" : moedaRealLocaleValue(row.salario_Ano5)}</StyledTableCell>

                                                            </StyledTableRow >
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>

                                        </Grid>
                                        <Grid size={{ xs: 12, sm: 12 }} padding={2}>
                                            <hr />
                                        </Grid>
                                    </>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </LayoutBaseDePagina>
    )
}

